import type React from "react"
import styled from "styled-components"

interface StyledFormProps {
  width?: string
  padding?: string
  margin?: string
}

const StyledForm = styled.form<StyledFormProps>`
  box-sizing: border-box;
  width: ${(props) => props.width};
  padding: ${(props) => props.padding};
  margin: ${(props) => props.margin};
`

interface FormProps {
  preventDefault?: boolean
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void
  outerRef?: React.Ref<HTMLFormElement>
  className?: string
  style?: React.CSSProperties
}

export const Form: React.CFC<FormProps> = ({
  preventDefault,
  onSubmit,
  children,
  outerRef,
  className,
  style,
  ...formProps
}) => {
  return (
    <StyledForm
      {...formProps}
      ref={outerRef}
      className={className}
      style={style}
      onSubmit={(event) => {
        if (preventDefault) event.preventDefault()
        onSubmit(event)
      }}
    >
      {children}
    </StyledForm>
  )
}
